import api from "@/api"

const state = {
    promoList: [],
    promoDetail: {}
}

const actions = {
    getPromos({ commit }, { params }) {
        return new Promise((resolve, reject) => {
            api.promo.promos(params).then(
                (response) => {
                    commit("setPromos", response.data)
                    resolve(response)
                },
                (error) => {
                    reject(error)
                }
            )
        })
    },
    createPromo({ _ }, { payloads }) {
        return new Promise((resolve, reject) => {
            api.promo.createPromo(payloads).then(
                (response) => {
                    resolve(response)
                },
                (error) => {
                    reject(error)
                }
            )
        })
    },
    getPromoDetail({ commit }, { id }) {
        return new Promise((resolve, reject) => {
            api.promo.getPromoDetail(id).then(
                (response) => {
                    commit("setPromoDetail", response.data.data)
                    resolve(response)
                },
                (error) => {
                    reject(error)
                }
            )
        })
    },
    updatePromo({ _ }, { id, payloads }) {
        return new Promise((resolve, reject) => {
            api.promo.updatePromo(id, payloads).then(
                (response) => {
                    resolve(response)
                },
                (error) => {
                    reject(error)
                }
            )
        })
    },
    deletePromo({ _ }, { id }) {
        return new Promise((resolve, reject) => {
            api.promo.deletePromo(id).then(
                (response) => {
                    resolve(response)
                },
                (error) => {
                    reject(error)
                }
            )
        })
    }
}

const mutations = {
    setPromos(state, value) {
        state.promoList = value
    },
    setPromoDetail(state, value) {
        state.promoDetail = value
    }
}

const getters = {
    promoList: (state) => state.promoList,
    promoDetail: (state) => state.promoDetail
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
